import * as dtos from "@/models/dtos";
import { useStore } from "vuex";
import { Permission } from "./Permission";
import { MainContainer } from "./MainContainer";
import { PermissionMatrix } from "./PermissionMatrix";

export class ContainerUser {
  store = useStore();

  Permissions: Permission[] = [];
  AvaiablePermissions: Permission[] = [];
  Container: MainContainer;
  Email = "";
  Firstname = "";
  Lastname = "";
  PhoneNumber = "";
  PermissionId = 0;
  Name = "";
  Id = 0;
  UserId = "";
  Title = "";
  PermissionMatrix = new Array<PermissionMatrix>();

  constructor(user: dtos.ApplicationUserResponse, container: MainContainer) {
    this.Firstname = user.firstname;
    this.Lastname = user.lastname;
    this.Email = user.email.toLowerCase();
    this.Id = user.id;
    this.PermissionId = user.permissionId;
    this.UserId = user.userId;
    this.Container = container;
    this.PhoneNumber = user.phoneNumber;
    this.Title = user.title;
    this.setPermissions();
    this.getPermissionMatrix2();
  }

  private setPermissions() {
    const userPermissions = this.Container.DTO.users.filter((px) => {
      return px.userId === this.UserId;
    });

    this.Container.Permissions.forEach((element) => {
      userPermissions.forEach((userPermssion) => {
        if (element.Id == userPermssion.permissionId)
          this.Permissions.push(element);
      });
    });

    const difference_a1 = this.Permissions.filter(
      (x) => !this.Container.Permissions.includes(x)
    );

    const difference_a2 = this.Container.Permissions.filter(
      (x) => !this.Permissions.includes(x)
    );

    this.AvaiablePermissions = difference_a2;
  }
  getPermissionMatrix(): PermissionMatrix[] {
    const permissions = new Array<PermissionMatrix>();
    this.AvaiablePermissions.forEach((element) => {
      permissions.push(new PermissionMatrix(element, false));
    });
    this.Permissions.forEach((element) => {
      permissions.push(new PermissionMatrix(element, true));
    });
    return permissions;
  }
  private getPermissionMatrix2(): PermissionMatrix[] {
    this.AvaiablePermissions.forEach((element) => {
      this.PermissionMatrix.push(new PermissionMatrix(element, false));
    });
    this.Permissions.forEach((element) => {
      this.PermissionMatrix.push(new PermissionMatrix(element, true));
    });
    return this.PermissionMatrix;
  }

  saveUserProfile() {
    this.store.dispatch("updateAccount", this);

    // this.store.dispatch("updateAccount", this);
  }
  savePermissionsold(matrix: PermissionMatrix[]) {
    //

    const toAdd = matrix
      .filter((px) => {
        return px.IsSelected;
      })
      .map((px) => px.Permission)
      .filter((x) => !this.Permissions.includes(x))
      .map((px) => {
        const payLoad = new dtos.CreateContainerUserPermission();
        payLoad.permissionId = px.Id;
        payLoad.containerId = this.Container.DTO.id;
        payLoad.email = this.Email;
        return payLoad;
      });

    const toDelete = matrix
      .filter((px) => {
        return !px.IsSelected;
      })
      .map((px) => px.Permission)
      .filter((x) => !this.AvaiablePermissions.includes(x))
      .map((px) => {
        const payLoad = new dtos.DeleteContainerUserPermission();
        payLoad.id = this.Id;
        payLoad.containerId = this.Container.DTO.id;
        return payLoad;
      });

    this.store.dispatch("addContainerUserPermission", toAdd);
    this.store.dispatch("deleteContainerUserPermission", toDelete);
  }
  async savePermissions(matrix: PermissionMatrix[]) {
    //

    const toAdd = matrix
      .filter((px) => {
        return px.IsSelected;
      })
      .map((px) => px.Permission.Id);

    const item = new dtos.UpdateContainerUserPermission();
    item.containerId = this.Container.DTO.id;
    item.email = this.Email;
    item.permissionIds = toAdd;

    await this.store.dispatch("updateContainerUserPermissions", item);
  }

  isUserAdminOrEditor(): boolean {
    return (
      this.Permissions.filter((px) => px.Name === "Administrator").length > 0 ||
      this.Permissions.filter((px) => px.Name === "Write").length > 0
    );
  }

  isUserWriter(): boolean {
    return this.Permissions.filter((px) => px.Name === "Write").length > 0;
  }

  isUserReader(): boolean {
    return this.Permissions.filter((px) => px.Name === "Read").length > 0;
  }
}

export class NewUser {
  firstName = "";
  lastName = "";

  constructor(user: { firstName: string; lastName: string }) {
    this.firstName =
      user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1);
    this.lastName =
      user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1);
  }
}
